module.exports = __webpack_public_path__ + "img/24-linking-the-global-urban.775d1b93.jpg";